import React,{useRef, useState, useEffect, useContext} from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from './layouts/Main';
import Projects from './pages/Projects';
import QuickNote from './components/QuickNote';
import globalContext from './utils/globalContext';
import NotFound from "./pages/NotFound";
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

import publicRoutes from "./routes/PublicRoutes";
import protectedRoutes from "./routes/ProtectedRoutes";
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { APP_VERSION } from "./version";
// import css
import "./assets/css/remixicon.css";

// import scss
import "./scss/style.scss";

mapboxgl.accessToken = 'pk.eyJ1IjoiZXNwZW52aW5kciIsImEiOiJjbGZpOXoyamIyYW1wM3FuMXBidjlvcXl5In0.XDmLF8QmTyYR-PiDcnDFGQ';




// set skin on load
window.addEventListener("load", function () {
	let skinMode = localStorage.getItem("skin-mode");
	let HTMLTag = document.querySelector("html");

	if (skinMode) {
		HTMLTag.setAttribute("data-skin", skinMode);
	}
});

export default function App() {
		
	const QN = useRef(null);
	var dialogs = {};
		
	return (
		<React.Fragment>
			<DndProvider key={Math.random()} backend={HTML5Backend} context={window}>
			<globalContext.Provider value={{ QN, dialogs, APP_VERSION}}>
				<BrowserRouter basename="/">
					<Routes>
						<Route path="/" element={<Projects />}></Route>
						{protectedRoutes.map((route, index) => {
							return (
								<Route
									path={route.path}
									element={route.element}
									key={index}
								/>
							)
						})}
						<Route path="*" element={<NotFound />} />
					</Routes>
					<QuickNote ref={QN} />
				</BrowserRouter>
			</globalContext.Provider>
			</DndProvider>
		</React.Fragment>
	);
}